import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

const Body = forwardRef(({ children, className, style }, ref) => (
  <main
    ref={ref}
    className={twMerge(
      'col-span-full flex max-w-screen flex-col flex-nowrap px-4 lg:col-span-16 lg:px-0 lg:group-has-[>[data-sidebar=true]]/layout:col-span-12',
      className
    )}
    style={style}
  >
    {children}
  </main>
));

Body.displayName = 'Body';

Body.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  style: PropTypes.shape(),
};

export default Body;
